// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file parameter_undo.proto (package pipeex.parameterundo.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file parameter_undo.proto.
 */
export const file_parameter_undo: GenFile = /*@__PURE__*/
  fileDesc("ChRwYXJhbWV0ZXJfdW5kby5wcm90bxIXcGlwZWV4LnBhcmFtZXRlcnVuZG8udjEiqQEKGVByb2plY3RQYXJhbWV0ZXJVbmRvRW50cnkSFgoOcGFyYW1ldGVyX25hbWUYASABKAkSFgoOZXhpc3RlZF9iZWZvcmUYAiABKAgSHQoVcHJldmlvdXNfYmluZGluZ19raW5kGAMgASgJEh0KFXByZXZpb3VzX2NhdGVnb3J5X2lkcxgEIAMoAxIeChZwcmV2aW91c19ncm91cF90eXBlX2lkGAUgASgJQhCqAg1QaXBlZVguUHJvdG9zYgZwcm90bzM");

/**
 * Exact project-binding state captured by Revit immediately before one
 * setup mutation. Category element ids are stable inside the guarded document
 * and avoid locale-dependent category display names during compensation.
 *
 * @generated from message pipeex.parameterundo.v1.ProjectParameterUndoEntry
 */
export type ProjectParameterUndoEntry = Message<"pipeex.parameterundo.v1.ProjectParameterUndoEntry"> & {
  /**
   * @generated from field: string parameter_name = 1;
   */
  parameterName: string;

  /**
   * @generated from field: bool existed_before = 2;
   */
  existedBefore: boolean;

  /**
   * @generated from field: string previous_binding_kind = 3;
   */
  previousBindingKind: string;

  /**
   * @generated from field: repeated int64 previous_category_ids = 4;
   */
  previousCategoryIds: bigint[];

  /**
   * @generated from field: string previous_group_type_id = 5;
   */
  previousGroupTypeId: string;
};

/**
 * Describes the message pipeex.parameterundo.v1.ProjectParameterUndoEntry.
 * Use `create(ProjectParameterUndoEntrySchema)` to create a new message.
 */
export const ProjectParameterUndoEntrySchema: GenMessage<ProjectParameterUndoEntry> = /*@__PURE__*/
  messageDesc(file_parameter_undo, 0);

